


import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LgaIdentificationDetailsComponent } from '../lga-identification-details/lga-identification-details.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PaymentModalComponent } from 'src/app/shared/modals/payment-modal/payment-modal.component';
import { environment } from 'src/environments/environment';

enum View {
  MY_ASSESSMENTS = 'MY_ASSESSMENTS',
  PENDING = 'PENDING',
  ALL = 'ALL'
}

@Component({
  selector: 'app-lga-identification-landing',
  standalone: false,
  templateUrl: './lga-identification-landing.component.html',
  styleUrl: './lga-identification-landing.component.scss'
})
export class LgaIdentificationLandingComponent {
  action_idx: any = null;

  dataList: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();


  showTabs: boolean = true;

  View = View;
  activeTab: View;
  downloadingCertificate: boolean;




  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.showTabs = this.hasAccess(['CAN_APPROVE_LGA_IDENTIFICATION', 'CAN_QUERY_LGA_IDENTIFICATION', 'CAN_CREATE_LGA_IDENTIFICATION',  'CAN_CREATE_LGA_IDENTIFICATION', ]);

    if (this.showTabs) {
      if(this.hasAccess(['CAN_APPROVE_LGA_IDENTIFICATION',])) {
        this.activeTab = View.PENDING;

      }

      if(this.hasAccess(['CAN_CREATE_LGA_IDENTIFICATION',])) {
        this.activeTab = View.MY_ASSESSMENTS;
      }
    }


    this.form = this.fb.group({
      applicationId: [''],
      approvalStatus: [''],
      paymentStatus: [''],
      from: [''],
      to: [''],
      offset: [''],
    });
    this.getFilteredApplications();
  }



  clearSearchFilters() {
    this.form.reset()
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  setIsActive(tab: any) {

    this.activeTab = tab;

    this.getFilteredApplications()

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  getFilteredApplications() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    const searchAndFilterValues = this.form?.value;



    var filterParams: any = new FormData();
    // filterParams.append('offset', this.num);
    // filterParams.append('limit', this.selectedLimit);
    // filterParams.append("assessmentId", this.form.get('assessmentId')?.value || '');
    // filterParams.append("approvalStatus", this.form.get('approvalStatus')?.value || '');
    // filterParams.append("paymentStatus", this.form.get('paymentStatus')?.value || '');
    // filterParams.append("from", this.form.get('from')?.value || '');
    // filterParams.append("to", this.form.get('to')?.value || '');
    // filterParams.append("workflowName", "ASSESSMENT");

    filterParams.append('offset', this.num);
    filterParams.append('limit', this.selectedLimit);
    filterParams.append("from", this.form.get('from')?.value || '');
    filterParams.append("to", this.form.get('to')?.value || '');
    filterParams.append("applicationId", this.form.get('applicationId')?.value || '');

    filterParams.append("workflowName", "LGA_IDENTIFICATION");


    const activeTab = this.activeTab;


    switch (activeTab) {
      case 'PENDING': {
        this.fetchPendingWorkflowLogs(filterParams, activeTab);
        break;
      }

      case 'MY_ASSESSMENTS': {
        this.fetchMyApplications(filterParams, activeTab);
        break
      }

      case 'ALL': {
        this.fetchEntities(filterParams, activeTab);
        break
      }


      default: {

        this.fetchEntities(filterParams, activeTab);
        return;
      }
    }
  }




  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openDeactivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Deactivate admin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deactivateAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  downloadId: any;

  openActivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Activate Admin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.activateAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  openPaymentModal(data: any) {
      this.dialog.open(PaymentModalComponent, {
        width: '400px',
        backdropClass: 'modal-form-backdrop',
        hasBackdrop: true,
        disableClose: true,
        panelClass: ['modal-form', 'custom-dialog-md'],
        data: {

          paymentTitle: 'Application Fee',
          paymentAmount: 4000,

        },



      }).afterClosed().subscribe((res: any) => {
        if (res.reload) {

        }
      })
    }

  openDeleteConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Delete sadmin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deleteAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  deleteAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/delete/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin deleted successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  deactivateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/deactivate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin deactivated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  activateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/activate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin activated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.getFilteredApplications();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.getFilteredApplications();
  }

  errorFetchingData: boolean = false;



  fetchWorkflowLogs(filterParams: FormData, activeTab: string) {

    this.apiService
      .post('/lga-identification/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({...item ,entity: {...item} }));


          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  fetchPendingWorkflowLogs(filterParams: FormData, activeTab: string) {

    this.apiService
      .post('/workflow/pending/logs/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({...item ,entity: {...item.entity, id: item.entity.entityId} }));


          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  fetchMyApplications(filterParams: FormData, activeTab: string) {

    this.apiService
      .post('/lga-identification/my/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({ entity: item }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  fetchEntities(filterParams: FormData, activeTab: string) {

    this.apiService
      .post('/lga-identification/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({ entity: item }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }




  openViewModal(data: any) {
    let dialog = this.dialog.open(LgaIdentificationDetailsComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-xl'],
      disableClose: true,

      data,
    })

    dialog.afterClosed().subscribe((data) => {
      if(data.reload) {
        this.getFilteredApplications()
      }
    })
  }

  // openUpdateModal(data: any) {
  //   let dialog = this.dialog.open(IgrAssessmentAsinVerificationModalComponent, {
  //     width: '400px',
  //     backdropClass: 'modal-form-backdrop',
  //     hasBackdrop: true,
  //     panelClass: ['modal-form', 'custom-dialog-xl'],
  //     disableClose: true,

  //     data: { ...data, isInEditingMode: true },
  //   })
  // }



  create() {
    this.router.navigate(['/admin/lga-identification/create'])
  }





  openEditDialogRef(data?: any) {
    let dialogRef = this.dialog.open(LgaIdentificationDetailsComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,
      panelClass: ['modal-form',],
      data,
    });

    return dialogRef;
  }


  editRole(role: any) {

    let dialogRef = this.openEditDialogRef(role);

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.getFilteredApplications();
      }
    });
  }


  startInterswitch(assessment: any) {
    const url = '/payment/initialize';

    const details = {
      paymentAmount: assessment?.amount,
      callbackUrl: environment.envUrl + 'admin/lga-identification',
      email: '',
      phoneNumer: assessment?.phoneNumber,
      asin: assessment?.phoneNumber,
      revenueName: "APPLICATION FEE ON STREET NAMING",
      entityId: assessment?.id,
      entityType: "LGA_IDENTIFICATION"
    };
    this.apiService.post(url, details).subscribe({
      next: (response) => {
        this.checkout(response.data);
      },
      error: (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      },
    });
  }

  checkout(details: any) {
    var paymentRequest = {
      merchant_code: details?.merchantCode,
      pay_item_id: details?.payItemId,
      txn_ref: details?.orderId,
      cust_id: details?.customerId,
      amount: Math.round((details?.amount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: (response: any) => this.paymentCallback(response),
      mode: details?.mode,
    };

    if (
      details?.mode === 'LIVE' &&
      details?.splitAccounts &&
      Object.keys(details?.splitAccounts).length > 0
    ) {
      paymentRequest['split_accounts'] = JSON.stringify(details?.splitAccounts);
    }

    (window as any).webpayCheckout(paymentRequest);
  }

  openPaymentSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getFilteredApplications()
    });
  }

  paymentCallback(response: any) {

    const url = '/payment/acknowledge?orderId=' + response?.txnref;
    this.apiService.post(url, {}).subscribe(
      (response) => {

        if(response.status == 'OK'){

        this.openPaymentSuccessModal("Payment made successfully")

      }
      },
      (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      }
    );
    return;
  }

  downloadCertificate(item: any){

    this.downloadingCertificate = true

    let url = "/lga-identification/download/local-id/certificate";

    this.apiService.post(url, item, { responseType: 'blob' }).subscribe(
        (response: Blob) => {

          const blob = new Blob([response], { type: 'application/pdf' });

          const blobUrl = window.URL.createObjectURL(blob);

          const file = new Blob([response], { type: 'application/pdf' });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);


          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.target = '_blank';
          downloadLink.download = 'lga_identification_certificate.pdf';

          downloadLink.click();

          this.downloadingCertificate = false
        },
        (error) => {
          this.downloadingCertificate = false
          this.openErrorModal(error?.message);
        }
    );

  }

}
